const TypeSuggestionEnum = {
  Email: 0,
  Name: 1,
  Phone: 2,
  Other: 3,
  Dimension: 4
}

export default TypeSuggestionEnum
